import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Select,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IUserKitSize } from "../../../models/userkitsize.model";
import routes from "../../../pages/routes";
import registrationService from "../../../services/registration.service";
import userkitsizeService from "../../../services/userkitsize.service";

const KitSize = ({ prePage, ...rest }: { prePage: any }) => {
  const navigate = useNavigate();
  const [size, setSize] = useState<any[]>([]);
  const [shoe, setShoe] = useState<any[]>([]);
  const [userKitsize, setUserKitsize] = useState<IUserKitSize[] | undefined>();
  const [loading, setLoading] = useState(true);

  const toast = useToast();

  useEffect(() => {
    userkitsizeService.getUserKitsize().then((res) => {
      if (res) {
        setUserKitsize(res.data.slice(-1));
        setLoading(false);
        setRegisteredKitsize();
      }
    });

    setSize(kitsize);
    setShoe(shoesize);
  }, [userKitsize?.length]);

  const kitsize = [
    {
      id: "1",
      title: "sm",
    },
    { id: "2", title: "M" },
    { id: "3", title: "X" },
    {
      id: "4",
      title: "XL",
    },
    {
      id: "5",
      title: "XXL",
    },
    {
      id: "6",
      title: "XXXL",
    },
  ];
  const shoesize = [
    {
      id: "0",
      title: "37",
    },
    {
      id: "1",
      title: "38",
    },
    {
      id: "2",
      title: "39",
    },
    {
      id: "3",
      title: "40",
    },
    {
      id: "4",
      title: "41",
    },
    {
      id: "5",
      title: "42",
    },
    {
      id: "6",
      title: "43",
    },
    {
      id: "7",
      title: "44",
    },
    {
      id: "8",
      title: "45",
    },
    {
      id: "9",
      title: "46",
    },
    {
      id: "10",
      title: "47",
    },
  ];

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.shirtSize) {
        errors.firstName = "Shirt size is required";
      }
      if (!values.overallSize) {
        errors.overallSize = "Overall is required";
      }
      if (!values.shoeSize) {
        errors.shoeSize = "Shoe size is required";
      }

      return errors;
    },
    initialValues: {
      shirtSize: "",
      overallSize: "",
      shoeSize: "",
    },
    onSubmit: async (values) => {
      const kitSize: any = {
        shirt_size: values.shirtSize,
        shirt_color: "",
        overall_size: values.overallSize,
        overall_color: "",
        shoe_color: "",
        shoe_size: values.shoeSize,
      };

      try {
        const basicResponse = await registrationService.updateKitSize(kitSize);
        if (basicResponse) {
                    localStorage.setItem("completed", "true");
          navigate(routes.Dashboard);
          toast({
            title: "Registration",
            description: "Kit details updated successfully",
            status: "success",
          });
        }
      } catch (error) {
        toast({
          title: "Registration",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });
  const setRegisteredKitsize = () => {
        if (userKitsize) {
      formik.setValues({
        shirtSize: userKitsize[0]?.shirt_size,
        overallSize: userKitsize[0]?.overall_size,
        shoeSize: userKitsize[0]?.shoe_size,
      });
    }
  };

  return (
    <Box px={6} mb="50px">
      <Flex justifyContent="center" mb="35px">
        <Text mx="auto" fontSize="32px" fontWeight="800">
          Kit Size
        </Text>
      </Flex>
      <Text mb="35px" color="#9E9E9E" fontSize="14px">
        All fields in{" "}
        <Text as="span" color="red">
          (*){" "}
        </Text>
        are required
      </Text>

      <form onSubmit={formik.handleSubmit}>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.shirtSize && formik.touched.shirtSize ? true : false
          }
        >
          <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
            T-Shirt Size{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Select T-shirt Size"
            value={formik.values.shirtSize}
            name="shirtSize"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {size.map((each) => (
              <option key={each.id} value={each.level_id}>
                {" "}
                {each.title}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.shirtSize}
          </FormErrorMessage>
        </FormControl>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.overallSize && formik.touched.overallSize
              ? true
              : false
          }
        >
          <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
            Overall size{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Select Overall Size"
            value={formik.values.overallSize}
            name="overallSize"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {size.map((each) => (
              <option key={each.id} value={each.level_id}>
                {" "}
                {each.title}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.overallSize}
          </FormErrorMessage>
        </FormControl>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.shoeSize && formik.touched.shoeSize ? true : false
          }
        >
          <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
            Shoe size{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Select Shoe Size"
            value={formik.values.shoeSize}
            name="shoeSize"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {shoe.map((each) => (
              <option key={each.id} value={each.level_id}>
                {" "}
                {each.title}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.shoeSize}
          </FormErrorMessage>
        </FormControl>

        <Flex
          mb="100px"
          justifyContent="space-between"
          alignItems="flex-end"
          mt={6}
        >
          <Box>
            <Button
              onClick={prePage}
              colorScheme="white"
              color="red"
              size="sm"
              fontSize={11}
              borderRadius={10}
              px={10}
            >
              PREVIOUS
            </Button>
          </Box>
          <HStack alignItems="flex-end">
            <Button
              colorScheme="white"
              color="red"
              size="sm"
              fontSize={11}
              borderRadius={10}
              px={10}
            >
              Save & Exit
            </Button>
            <Button
              py="13px"
              px="30px"
              mt="30px"
              type="submit"
              fontSize={11}
              isLoading={formik.isSubmitting}
              borderRadius={0}
              colorScheme="red"
              size="sm"
            >
              SUBMIT
            </Button>
          </HStack>
        </Flex>
      </form>
    </Box>
  );
};

export default KitSize;
